import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Text } from '@amzn/storm-ui';
import useIntl from '@i18n/useIntl';
import ReadOnlyFormField from '@components/form/ReadOnlyFormRow';
import { toggleAccountInfoEditMode } from 'src/shared/state/account-settings-slice';
import { FORM_CHANGE_BUTTON_TRANSLATION_KEY } from 'src/pages/accountSettings/constants';
import * as accountInfoConstants from '@features/account-settings/constants';
import {
  ActionsButtonsWrapper,
  ControllersWrapper,
  TextWithCommaSeparator,
  TextWithSpaceSeparator,
  ViewWrapper,
} from '@components/form/style';

const AccountDetailsViewer = () => {
  const dispatch = useDispatch();
  const { intl } = useIntl();
  const { getValues } = useFormContext();
  const addressLine1 = getValues(
    accountInfoConstants.BUSINESS_DETAILS_ADDRESS_LINE1_FIELD_CONTROLLER_NAME,
  );
  const addressLine2 = getValues(
    accountInfoConstants.BUSINESS_DETAILS_ADDRESS_LINE2_FIELD_CONTROLLER_NAME,
  );
  const city = getValues(
    accountInfoConstants.BUSINESS_DETAILS_CITY_FIELD_CONTROLLER_NAME,
  );
  const state = getValues(
    accountInfoConstants.BUSINESS_DETAILS_STATE_FIELD_CONTROLLER_NAME,
  );
  const postalCode = getValues(
    accountInfoConstants.BUSINESS_DETAILS_POSTAL_CODE_FIELD_CONTROLLER_NAME,
  );
  const country = getValues(
    accountInfoConstants.BUSINESS_DETAILS_COUNTRY_FIELD_CONTROLLER_NAME,
  );
  const currency = getValues(
    accountInfoConstants.ACCOUNT_CURRENCY_FIELD_CONTROLLER_NAME,
  );
  const timezone = getValues(
    accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_CONTROLLER_NAME,
  );
  const industry = getValues(
    accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_CONTROLLER_NAME,
  );

  return (
    <ViewWrapper>
      <ControllersWrapper>
        <ReadOnlyFormField
          label={intl.getMessage(
            accountInfoConstants.BUSINESS_DETAILS_NAME_FIELD_LABEL,
          )}
          id={accountInfoConstants.BUSINESS_DETAILS_NAME_FIELD_ID}
          value={getValues(
            accountInfoConstants.BUSINESS_DETAILS_NAME_FIELD_CONTROLLER_NAME,
          )}
        />
        <ReadOnlyFormField
          label={intl.getMessage(
            accountInfoConstants.BUSINESS_DETAILS_PHONE_FIELD_LABEL,
          )}
          id={accountInfoConstants.BUSINESS_DETAILS_PHONE_FIELD_ID}
          value={getValues(
            accountInfoConstants.BUSINESS_DETAILS_PHONE_FIELD_CONTROLLER_NAME,
          )}
        />
        <ReadOnlyFormField
          label={intl.getMessage(
            accountInfoConstants.BUSINESS_DETAILS_WEBSITE_FIELD_LABEL,
          )}
          id={accountInfoConstants.BUSINESS_DETAILS_WEBSITE_FIELD_ID}
          value={getValues(
            accountInfoConstants.BUSINESS_DETAILS_WEBSITE_FIELD_CONTROLLER_NAME,
          )}
        />
        <ReadOnlyFormField
          label={intl.getMessage(
            accountInfoConstants.BUSINESS_DETAILS_ADDRESS_FIELD_LABEL,
          )}
          id={accountInfoConstants.BUSINESS_DETAILS_ADDRESS_FIELD_ID}
        >
          <>
            {addressLine1 && (
              <TextWithCommaSeparator renderAs="span" color="secondary">
                {addressLine1}
              </TextWithCommaSeparator>
            )}
            {addressLine2 && (
              <TextWithCommaSeparator renderAs="span" color="secondary">
                {addressLine2}
              </TextWithCommaSeparator>
            )}
            {city && (
              <TextWithCommaSeparator renderAs="span" color="secondary">
                {city}
              </TextWithCommaSeparator>
            )}
            {state && (
              <TextWithSpaceSeparator renderAs="span" color="secondary">
                {state}
              </TextWithSpaceSeparator>
            )}
            {postalCode && (
              <TextWithCommaSeparator renderAs="span" color="secondary">
                {postalCode}
              </TextWithCommaSeparator>
            )}
            {country && (
              <Text renderAs="span" color="secondary">
                {country}
              </Text>
            )}
          </>
        </ReadOnlyFormField>
        <ReadOnlyFormField
          label={intl.getMessage(
            accountInfoConstants.BUSINESS_DETAILS_REGISTRATION_NUMBER_FIELD_LABEL,
          )}
          id={
            accountInfoConstants.BUSINESS_DETAILS_REGISTRATION_NUMBER_FIELD_ID
          }
          value={getValues(
            accountInfoConstants.BUSINESS_DETAILS_REGISTRATION_NUMBER_FIELD_CONTROLLER_NAME,
          )}
        />
        {currency && (
          <ReadOnlyFormField
            label={intl.getMessage(
              accountInfoConstants.ACCOUNT_CURRENCY_FIELD_LABEL,
            )}
            id={accountInfoConstants.ACCOUNT_CURRENCY_FIELD_ID}
            value={currency}
          />
        )}
        {timezone && (
          <ReadOnlyFormField
            label={intl.getMessage(
              accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_LABEL,
            )}
            id={accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_ID}
            value={timezone}
          />
        )}
        {industry && (
          <ReadOnlyFormField
            label={intl.getMessage(
              accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_LABEL,
            )}
            id={accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_ID}
            value={industry}
          />
        )}
      </ControllersWrapper>
      <ActionsButtonsWrapper>
        <Button onClick={() => dispatch(toggleAccountInfoEditMode())}>
          {intl.getMessage(FORM_CHANGE_BUTTON_TRANSLATION_KEY)}
        </Button>
      </ActionsButtonsWrapper>
    </ViewWrapper>
  );
};

export default AccountDetailsViewer;
